import React from 'react';

// Components
import OrderingList from "./orderingList";

// Constants
import { PAGE, PAGE_NAME } from '@utils/constants';

function OrderingReserve(props) {

    const BREADCRUMB = [
        {
            path: PAGE.ORDER_TO_BE_TERMINATE,
            name: PAGE_NAME.ORDER_TO_BE_TERMINATE
        }
    ];

    const availableOrderingStatus = ['toBeTerminate'];

    return (
        <OrderingList {...props} breadcrumb={BREADCRUMB} availableOrderingStatus={availableOrderingStatus}/>
    );
}

export default OrderingReserve;
